import { render, staticRenderFns } from "./quotationsList.vue?vue&type=template&id=b985ca38&scoped=true&"
import script from "./quotationsList.vue?vue&type=script&lang=js&"
export * from "./quotationsList.vue?vue&type=script&lang=js&"
import style0 from "./quotationsList.vue?vue&type=style&index=0&id=b985ca38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b985ca38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
